import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAppContext } from 'Context/ReactAppContext';
import { getDataScore } from 'Utils/tracking/dataScore';
import { setDataScore } from 'Store/lead-info/leadInfos.action';
import { getCurrentProposal, getCurrentResort } from 'Store/booking/booking.selector';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import {
  getFromSessionStorage,
  setInSessionStorage,
} from 'Client/session-storage-api/sessionStorageApi';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import * as trackingApi from 'Tracking/tracking-api';
import { DATA_SCORE_SESSION_STORAGE_KEY } from 'Store/lead-info/constants';
import { GA_DEFAULT_PAYLOAD } from 'Tracking/constants';
import { usePageContext } from 'Context/PageContext';
let pendingDataScoreTimeout = null;

/*
 * the following function is used to execute the fn arg on the last call only
 * the previous scheduled call to fn will be canceled at every new call
 * by clearing the setTimeout id stored in pendingDataScoreTimeout
 *
 */
const takeLast = (fn: (...args: Array<any>) => any): void => {
  clearTimeout(pendingDataScoreTimeout);
  // 5000ms is choosed arbitrarily
  pendingDataScoreTimeout = setTimeout(fn, 5000);
};

let neolaneId = null;

const DataScore = () => {
  const appContext = useAppContext();
  const { isAppMounted } = useResponsive();
  const pageContext = usePageContext();
  const selectedProposal = useSelector(getCurrentProposal);
  const resort = useSelector(getCurrentResort);
  const dispatch = useDispatch();
  const dataScoreHasBeenFetched = !!getFromSessionStorage(DATA_SCORE_SESSION_STORAGE_KEY);
  useEffect(() => {
    if (
      isFeatureFlipped(appContext)('enableLeadScoring') &&
      isAppMounted && // neolaneId will change after user sign in
      ((!neolaneId && appContext.neolaneId) ||
        (!dataScoreHasBeenFetched && (appContext.neolaneId || appContext.googleTrackingId)))
    ) {
      neolaneId = appContext.neolaneId;

      /*
           every calls to the lead scoring API is billed so we want to make
           sure there is only one call to be done when the app state is stabilized
         */
      takeLast(() => {
        getDataScore({
          ...(selectedProposal
            ? {
                departureDate: selectedProposal.departureDate,
              }
            : null),
          ...(resort
            ? {
                resortId: resort.id,
              }
            : null),
          appContext,
        })
          .then(({ dataScore: { leadScoring } }) => {
            const score = parseFloat(leadScoring);
            trackingApi.setDataLayer(
              { ...GA_DEFAULT_PAYLOAD, event: 'leadScoring', leadScoring: score },
              appContext,
              pageContext.pageId,
            );
            dispatch(setDataScore(leadScoring));
            setInSessionStorage(DATA_SCORE_SESSION_STORAGE_KEY, leadScoring);
          })
          .catch(() => {
            /* we don't do anything if the call fails */
          });
      });
    }
  }, [isAppMounted, appContext, selectedProposal]);
  return null;
};

export { DataScore };
